module.exports = __webpack_public_path__ + "img/813-d111fc.png";